import React from 'react';
import LocationTemplate from './LocationTemplate';

const ThelmaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Thelma"
      stateName="North Carolina"
      countyName="Halifax"
      zipCodes={["27871"]}
      latitude={36.4979}
      longitude={-77.7192}
      population={135}
      historicalFact="Small unincorporated community near the Virginia border, established as a railroad stop."
      nearbyTowns={[
        "Roanoke Rapids, NC",
        "Weldon, NC",
        "Gaston, NC",
        "Garysburg, NC",
        "Halifax, NC",
        "Enfield, NC",
        "Littleton, NC",
        "South Hill, VA"
      ]}
    />
  );
};

export default ThelmaPage;